import { render, staticRenderFns } from "./emailColctDenyPage.vue?vue&type=template&id=10b03c74&"
import script from "./emailColctDenyPage.vue?vue&type=script&lang=js&"
export * from "./emailColctDenyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports